/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `WAITING_FOR_DOWNLOAD` - WAITING_FOR_DOWNLOAD
 *   * `DOWNLOADING` - DOWNLOADING
 *   * `DOWNLOAD_FAILED` - DOWNLOAD_FAILED
 *   * `WAITING_FOR_IMPORT` - WAITING_FOR_IMPORT
 *   * `IMPORTING` - IMPORTING
 *   * `IMPORT_FAILED` - IMPORT_FAILED
 *   * `IMPORTED` - IMPORTED
 * ```
 */
export const EpsiDocStatesEnum = {
  WAITING_FOR_DOWNLOAD: 'WAITING_FOR_DOWNLOAD',
  DOWNLOADING: 'DOWNLOADING',
  DOWNLOAD_FAILED: 'DOWNLOAD_FAILED',
  WAITING_FOR_IMPORT: 'WAITING_FOR_IMPORT',
  IMPORTING: 'IMPORTING',
  IMPORT_FAILED: 'IMPORT_FAILED',
  IMPORTED: 'IMPORTED',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type EpsiDocStatesEnum = ValuesOf<typeof EpsiDocStatesEnum>;

export type EpsiDocStatesEnumRequest = EpsiDocStatesEnum;
export type EpsiDocStatesEnumResponse = EpsiDocStatesEnum;
